<template>
  <div v-show="isActive" id="purchase_confirm" class="popup-frame" :class="{ active: isActive }">
    <div class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable justify-content-center">
      <div class="popup-package iframe-full-screen">
        <button class="btn-close" @click="hideModel" />
        <div class="popup-content">
          <div class="popup-header" />
          <div class="popup-body" style="width: 100%; height: calc(100dvh - 230px);">
            <template v-if="selectedProd && selectedProd.type === 1">
              <div class="row">
                <div class="align-items-space-between">
                  <div class="title">
                    {{ $t('Bao.type_name_title_1') }}：
                    <span class="exchange-t1">{{ selectedProd.type_name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_2') }}：
                    <span class="exchange-t2">{{ selectedProd.name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_3') }}：
                    <span class="exchange-t3">{{ selectedProd.amount }}</span>
                  </div>
                  <div v-if="selectedProd && selectedProd.setting" class="title">
                    {{ $t('Bao.type_name_title_4') }}：
                    <span class="exchange-t4">{{ selectedProd.vip.join('/') }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_16') }}：{{ $t('Bao.type_name_title_17') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="align-items-space-between">
                  <div class="title">
                    {{ $t('Bao.confirm_purchase') }}
                  </div>
                  <ol>
                    <li>
                      {{ $t('Bao.purchase_notice_1') }}
                      <br>
                      {{ $t('Bao.purchase_notice_2') }}
                    </li>
                    <li>
                      {{ $t('Bao.purchase_notice_3') }}
                      <br>
                      {{ $t('Bao.purchase_notice_4') }}
                    </li>
                    <li>
                      {{ $t('Bao.purchase_notice_5') }}
                      <br>
                      {{ $t('Bao.purchase_notice_6') }}
                    </li>
                  </ol>
                </div>
              </div>
            </template>
            <template v-if="selectedProd && selectedProd.type === 2">
              <div class="row">
                <div class="align-items-space-between">
                  <div class="title">
                    {{ $t('Bao.type_name_title_5') }}：
                    <span class="exchange-t1">{{ selectedProd.type_name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_6') }}：
                    <span class="exchange-t2">{{ selectedProd.type_name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_7') }}：
                    <span class="exchange-t3">{{ selectedProd.upgrade_prize | numberFormat }}{{ $t('Bao.point_unit_2') }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="selectedProd && selectedProd.type === 3">
              <div class="row">
                <div class="align-items-space-between">
                  <div class="title">
                    {{ $t('Bao.type_name_title_8') }}：
                    <span class="exchange-t1">{{ selectedProd.type_name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_9') }}：
                    <span class="exchange-t2">{{ selectedProd.name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_10') }}：
                    <span class="exchange-t3">{{ selectedProd.amount }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_11') }}：
                    <span class="exchange-t4">{{ formatDate(selectedProd.created_at) }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="selectedProd && selectedProd.type === 4">
              <div class="row">
                <div class="align-items-space-between">
                  <div class="title">
                    {{ $t('Bao.type_name_title_13') }}：<span class="exchange-t1">{{ $t('Bao.free_spin') }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_14') }}：<span class="exchange-t2">{{ selectedProd.name }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.free_spin_unit') }}：
                    <span class="exchange-t3">{{ selectedProd.freeCount }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_15') }}：
                    <span class="exchange-t4">{{ selectedProd.amount }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_4') }}：
                    <span class="exchange-t5">{{ selectedProd.vip.join('/') }}</span>
                  </div>
                  <div class="title">
                    {{ $t('Bao.type_name_title_16') }}：
                    <span class="exchange-t6">{{ $t('Bao.type_name_title_17') }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="popup-footer my-mall-popup-ft-frame">
            <div class="mall-exchange-footer">
              <div class="plus-minus-input-frame ">
                <div class="amount-value-frame">
                  <span>{{ $t('Bao.amount_shop') }}</span>：
                  <input
                    v-model="localQuantity"
                    class="input-group-field total-exchange-amount"
                    type="number"
                    :min="1"
                    disabled=""
                  >
                </div>

                <div class="input-group plus-minus-input">
                  <div class="input-group-button">
                    <button
                      type="button"
                      class="btn-minus"
                      :class="{ disabled: isMinusDisabled }"
                      data-quantity="minus"
                      data-field="quantity"
                      @click="decrement"
                    >
                      −
                    </button>
                  </div>
                  <input
                    v-model="localQuantity"
                    class="input-group-field"
                    type="number"
                    :min="1"
                    @change="validateInput"
                  >
                  <div class="input-group-button">
                    <button
                      type="button"
                      class="btn-plus"
                      :class="{ disabled: isPlusDisabled }"
                      data-quantity="plus"
                      data-field="quantity"
                      @click="increment"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <button
                v-if="selectedProd.availBuy"
                type="button"
                class="btn btn-secondary btn-style-outline-secondary btn-exchange"
                @click="confirmPurchase"
              >
                {{ $t('Bao.redeem') }}
              </button>
              <button v-else type="button" class="btn btn-secondary btn-style-outline-secondary btn-exchange-lock" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
    selectedProd: {
      type: Object,
      default: () => ({})
    },
    quantity: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      localQuantity: this.quantity,
      isDisabledPlus: false,
      isDisabledMinus: false
    }
  },
  computed: {
    point() {
      return Math.floor(Number(this.$store.getters.mainPoint))
    },
    isPlusDisabled() {
      if (this.selectedProd.type === 1 && this.selectedProd.availBuy) {
        const nextCost = (this.localQuantity + 1) * this.selectedProd.amount
        return this.point < nextCost
      } else return true
    },
    isMinusDisabled() {
      return this.localQuantity <= 1
    }
  },
  watch: {
    quantity: {
      immediate: true,
      handler(newValue) {
        this.localQuantity = newValue
      }
    }
  },
  created() {

  },
  methods: {
    hideModel() {
      this.$emit('hideModel')
      this.localQuantity = 1
    },
    confirmPurchase() {
      this.$store.commit('SET_SHOP_PURCHASE', true)
      this.$emit('hideModel')
    },
    increment() {
      if (this.selectedProd.type === 1 && this.selectedProd.availBuy) {
        const nextCost = (this.localQuantity + 1) * this.selectedProd.amount
        if (this.point >= nextCost) {
          this.localQuantity++
          this.$emit('update-quantity', this.localQuantity)
        } else {
          this.isDisabled = true
        }
      }
    },
    decrement() {
      if (this.selectedProd.type === 1 && this.localQuantity > 1) {
        this.localQuantity--
        this.$emit('update-quantity', this.localQuantity)
      } else {
        this.isDisabled = true
      }
    },
    formatDate(timestamp) {
      const date = new Date((timestamp + 73 * 3600) * 1000)
      // 有效時間,因為我們是＋8的時區～但日本是＋9, 得用created_at的時間＋73小時

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    validateInput(event) {
      const value = Number(event.target.value)
      if (this.selectedProd.type === 1 && this.selectedProd.availBuy) {
        if (value < 1) {
          this.localQuantity = 1
        } else if (value * this.selectedProd.amount > this.point) {
          this.localQuantity = Math.floor(this.point / this.selectedProd.amount)
        } else {
          this.localQuantity = value
        }
      } else {
        this.localQuantity = 1
      }

      this.$emit('update-quantity', this.localQuantity)
    }
  }
}
</script>
